import React, { useEffect } from "react";
import "@/App.css";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Header } from "@/components/sections/Header";
import { Hero } from "@/components/sections/Hero";
import { Concept } from "@/components/sections/Concept";
import { MenuSection } from "@/components/sections/MenuSection";
import { FullMenu } from "@/components/sections/FullMenu";
import { Reviews } from "@/components/sections/Reviews";
import { Location } from "@/components/sections/Location";
import { Footer } from "@/components/sections/Footer";
import { WhatsAppFAB } from "@/components/sections/WhatsAppFAB";

import { FoodHighlights } from "@/components/sections/FoodHighlights";
import { Events } from "@/components/sections/Events";

function App() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const timeoutId = setTimeout(() => {
        const element = document.getElementById(hash.slice(1));
        if (element) {
          element.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
        }
      }, 200);

      return () => clearTimeout(timeoutId);
    }
  }, []);

  return (
    <LanguageProvider defaultLang="en">
      <div className="App" data-testid="app-root">
        <Header />
        <main>
          <Hero />
          <FoodHighlights />
          <Concept />
          <MenuSection />
          <FullMenu />
          <Events />
          <Reviews />
          <Location />
        </main>
        <Footer />
        <WhatsAppFAB />
      </div>
    </LanguageProvider>
  );
}

export default App;
